import React from 'react';
import { CheckSquare } from 'lucide-react';
export function ContentBreakdown() {
  const modules = ['Fundamentos y materiales (qué comprar y qué evitar)', 'Aplicación paso a paso (mezcla, tiempos, terminación)', 'Técnicas decorativas premium (alto valor percibido)', 'Superficies industriales y alto tránsito', 'Presupuesto, costos y generación de ingresos'];
  return <section className="py-16 px-4 bg-[#0a0a0a]" data-id="element-54">
      <div className="max-w-3xl mx-auto" data-id="element-55">
        <h2 className="text-3xl md:text-4xl font-black text-center mb-10 text-white uppercase tracking-tight" data-id="element-56">
          📘 Contenido real del Mega Pack
        </h2>

        <p className="text-xl text-gray-400 text-center mb-8" data-id="element-57">
          El programa incluye:
        </p>

        <div className="space-y-4 mb-12" data-id="element-58">
          {modules.map((module, index) => <div key={index} className="flex items-start p-4 bg-[#1a1a1a] rounded-lg border border-amber-900/30" data-id="element-59">
              <CheckSquare className="w-6 h-6 text-amber-500 mr-4 mt-1 flex-shrink-0" data-id="element-60" />
              <span className="text-lg font-medium text-gray-200" data-id="element-61">
                {module}
              </span>
            </div>)}
        </div>

        <div className="bg-amber-900/20 text-amber-100 p-6 rounded-xl text-center border border-amber-800/40" data-id="element-62">
          <p className="text-lg md:text-xl font-medium" data-id="element-63">
            Está diseñado para que avances rápido y puedas cotizar en pocas
            semanas.
          </p>
        </div>

        <div className="w-full h-px bg-gray-800 mt-16" data-id="element-64"></div>
      </div>
    </section>;
}